<!-- eslint-disable prettier/prettier -->
<template>
  <div v-click-away="closeDropdown" class="gp_base-select" :class="className" @focus.prevent="focus">
    <select
      :id="id"
      :name="name"
      :disabled="disabled"
      :form="form"
      :multiple="multiple"
      :required="required"
      class="gp_base-select_model">
      <option v-for="item in options" :key="item.value">{{ item.text }}</option>
    </select>
    <template v-if="multiple">
      <div class="gp_base-select_container" :class="cclass">
        <div class="gp_base-select_display_hidden typo-p14 typo-regular text-light-high">{{ longestContent }}</div>
        <div
          ref="inputBounder"
          class="gp_base-select_display noselect"
          :class="[{ disabled: !options || options.length <= 1 }, { active: opening }, { 'hide-arrow': !arrow }]"
          tabindex="0"
          @click="toggleDropdown">
          {{ selectedText }}
        </div>
        <transition :name="'drop' + popupDirection">
          <div v-if="opening" ref="dropContain" class="gp_base-select_dropdown">
            <perfect-scrollbar class="scrollBody">
              <div
                v-for="(option, index) in options"
                :key="option.value + '' + index"
                class="gp_base-select_dropdown_item noselect"
                :class="{ active: val.indexOf(option.value) > -1 }"
                @click="updateValue(option.value)">
                <p class="typo-p14 typo-regular text-light-high">{{ option.text }}</p>
              </div>
            </perfect-scrollbar>
          </div>
        </transition>
      </div>
    </template>

    <template v-else>
      <div class="gp_base-select_container" :class="cclass">
        <div class="gp_base-select_display_hidden typo-p14 typo-regular text-light-high">{{ longestContent }}</div>
        <div
          class="gp_base-select_display noselect d-flex align-items-center"
          :class="[
            { disabled: !options || options.length <= 1 },
            { active: opening },
            { border: opening },
            { 'hide-arrow': !arrow },
          ]"
          tabindex="0"
          @click="toggleDropdown">
          <span class="gp_base-select_display-label mr-1">Sort: </span>
          <p class="typo-regular text-light-high overflow-hidden">{{ selectedText }}</p>
          <div class="gp_base-select_display-icon ml-1">
            <svg
              :class="{ transformY: opening }"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none">
              <path
                d="M2.64645 5.64645C2.84171 5.45118 3.15829 5.45118 3.35355 5.64645L8 10.2929L12.6464 5.64645C12.8417 5.45118 13.1583 5.45118 13.3536 5.64645C13.5488 5.84171 13.5488 6.15829 13.3536 6.35355L8.35355 11.3536C8.15829 11.5488 7.84171 11.5488 7.64645 11.3536L2.64645 6.35355C2.45118 6.15829 2.45118 5.84171 2.64645 5.64645Z"
                fill="#252525" />
            </svg>
          </div>
        </div>
        <transition :name="'drop' + popupDirection">
          <div v-if="opening" ref="dropContain" class="gp_base-select_dropdown">
            <perfect-scrollbar class="scrollBody">
              <div
                v-for="(option, index) in options"
                :key="option.value + '' + index"
                class="gp_base-select_dropdown_item noselect d-flex align-items-center"
                @click="updateValue(option.value)">
                <svg
                  v-if="option.value === selected"
                  class="mr-1"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M13.3981 4.24093C13.5933 4.43619 13.5933 4.75277 13.3981 4.94804L6.10551 12.2406C6.01174 12.3344 5.88456 12.3871 5.75195 12.3871C5.61934 12.3871 5.49216 12.3344 5.39839 12.2406L2.60152 9.44361C2.40626 9.24834 2.40627 8.93176 2.60153 8.7365C2.7968 8.54124 3.11338 8.54125 3.30864 8.73652L5.75196 11.1799L12.691 4.24093C12.8862 4.04567 13.2028 4.04567 13.3981 4.24093Z"
                    fill="#00C853" />
                </svg>
                <div v-else style="width: 16px; height: 16px" class="mr-1"></div>
                <p class="typo-p14 typo-regular text-light-high">{{ option.text }}</p>
              </div>
            </perfect-scrollbar>
          </div>
        </transition>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'BaseSelect',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    cclass: String,
    defaultText: {
      type: String,
      default: 'None',
    },
    defaultSelectedValue: {
      type: String,
    },
    id: {
      type: [String, Number, Boolean],
      default: false,
    },
    name: {
      type: [String, Number, Boolean],
      default: false,
    },
    form: {
      type: [String, Number, Boolean],
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    dropdownLabel: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      required: false,
      default() {
        return [
          {
            text: 'None',
            value: 'none',
          },
        ];
      },
    },
    value: {
      type: [String, Number, Array],
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
    arrow: {
      type: Boolean,
      default: true,
    },
    className: String,
  },
  emits: ['change', 'focus', 'blur', 'input:value', 'created', 'update:value'],
  data() {
    return {
      val: '',
      opening: false,
      selected: 'none',
      backup: [],
      inVP: true,
      elHeight: 0,
      defaultValue: '',
    };
  },
  computed: {
    popupDirection() {
      if (this.inVP) {
        return 'down';
      }
      return 'up';
    },
    selectedText() {
      if (this.multiple) {
        const selected = [];
        this.options.forEach((opt) => {
          if (this.val.indexOf(opt.value) > -1) selected.push(opt.text);
        });
        if (selected.length) return selected.join(', ');
        return 'None';
      } else {
        if (this.defaultValue !== '') {
          return this.defaultText;
        }
        const item = this.options.find((item) => item.value == this.selected);
        if (item) return item.text;
        return this.defaultText;
      }
    },
    longestContent() {
      if (this.options && this.options.length) {
        let max = '';

        this.options.forEach((item) => {
          if (item.text.length > max.length) max = item.text;
        });
        if (this.multiple) {
          return max + ', additional';
        }
        return max;
      }
      return 'None';
    },
  },
  watch: {
    value(newV, oldV) {
      this.defaultValue = '';
      if (oldV === newV) return;
      this.setValue(newV);
    },
    opening: {
      immediate: true,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      handler() {},
    },
    elHeight() {
      this.autoPosition();
    },
  },
  created() {
    this.$emit('created', this);

    if (this.defaultSelectedValue) {
      this.defaultValue = this.defaultSelectedValue;
      this.setValue(this.defaultValue);
    } else {
      this.setValue(this.value);
    }

    window.addEventListener('scroll', this.autoPosition);
    window.addEventListener('mousewheel', this.autoPosition);
    window.addEventListener('ps-scroll-y', this.autoPosition);
    window.addEventListener('resize', this.autoPosition);
    this.toggleDropdown();
    this.autoPosition();
    this.toggleDropdown();
  },
  unmounted() {
    window.removeEventListener('scroll', this.autoPosition);
    window.removeEventListener('mousewheel', this.autoPosition);
    window.removeEventListener('ps-scroll-y', this.autoPosition);
    window.removeEventListener('resize', this.autoPosition);
  },
  methods: {
    autoPosition() {
      if (!this.$refs) return;
      if (!this.$refs.inputBounder) return;
      const viewportTop = window.pageYOffset,
        viewportBottom = window.pageYOffset + window.document.documentElement.clientHeight - 80,
        rect = this.$refs.inputBounder.getBoundingClientRect(),
        elementTop = rect.top + viewportTop,
        elementBottom = elementTop + rect.height;
      if (elementBottom + this.elHeight <= viewportBottom) this.inVP = true;
      else this.inVP = false;
    },
    // Dropdown Controlling
    toggleDropdown() {
      // this.backup = JSON.parse(JSON.stringify(this.val));
      if (this.options && this.options.length > 1) this.opening = !this.opening;
      if (!this.opening) {
        // this.elHeight = 0
        if (this.$refs && this.$refs.dropContain) this.elHeight = this.$refs.dropContain.getBoundingClientRect().height;
      }
    },
    closeDropdown() {
      if (this.opening) {
        this.blur();
        this.opening = false;
        if (this.multiple) {
          if (this.val && this.val.length)
            if (this.backup.join(',') != this.val.join(',')) {
              this.backup = this.val;
              this.change();
            }
        }
      }
    },
    // Base
    updateValue(value) {
      if (this.multiple) {
        if (!Array.isArray(this.val)) {
          this.val = [];
        }
        const index = this.val.findIndex((opt) => opt === value);
        if (index > -1) this.val.splice(index, 1);
        else this.val.push(value);
        this.onChange();
      } else {
        const updated = this.setValue(value);
        if (updated) this.change();
        if (this.opening) this.opening = false;
      }
    },
    setValue(value) {
      if (this.multiple) {
        this.selected = value;
        this.val = value;
        return true;
      } else {
        if (value != this.val) {
          this.selected = value;
          this.val = value;
          return true;
        }
        return false;
      }
    },
    onChange() {
      this.$emit('update:value', this.val);
      // this.$emit("onChange", this.id, this.val);
    },
    change() {
      this.$emit('update:value', this.val);
      this.$emit('change', this.id, this.val);
    },
    focus() {
      this.$emit('focus', this.id, this.val);
    },
    blur() {
      this.$emit('blur', this.id, this.val);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';

$blue: #839bc0;
$text: #333333;
$textShade2: #7f7f7f;
$textShade3: #dadada;
.gp_base-select_model {
  display: none;
}
.ps > .ps__scrollbar-y-rail {
  right: -11px !important;
}
.gp_base-select {
  label {
    display: block;
  }
  .gp_base-select_container {
    position: relative;
    // min-width: 360px;
    display: flex;
    flex-direction: column;
  }
  .gp_base-select_display {
    position: relative;
    display: flex;
    flex: 1;
    outline: none;
    text-overflow: ellipsis;
    // -webkit-appearance: menulist;
    padding: 11px 33.5px 12px 7px;
    height: 40px;
    max-height: 40px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    cursor: pointer;
    border: solid 1px $bg;

    @include trans-all;

    p {
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
    }

    //new
    flex: 1;
    overflow: hidden;
    // border: none;

    &.disabled {
      cursor: default;
    }

    &:disabled {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
    }
  }

  .gp_base-select_display_hidden {
    display: flex;
    padding: 0px 40px 0px 16px;
    height: 0px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    overflow: hidden;
  }
  .gp_base-select_dropdown {
    position: absolute;
    top: 40px;
    left: 0px;
    right: 0px;
    width: 100%;
    border-radius: 5px;
    background-color: #ffffff;
    box-shadow: 0px 0.332071px 0.719487px rgba(0, 0, 0, 0.0168687), 0px 0.798012px 1.72903px rgba(0, 0, 0, 0.0242336),
      0px 1.50259px 3.2556px rgba(0, 0, 0, 0.03), 0px 2.68036px 5.80744px rgba(0, 0, 0, 0.0357664),
      0px 5.01331px 10.8622px rgba(0, 0, 0, 0.0431313), 0px 12px 26px rgba(0, 0, 0, 0.06);
    z-index: 12;
    min-width: 80px;

    // new
    // box-shadow: 0 0 10px 0px #8a8a8a;
    &-label {
      padding-top: 5px;
      padding-bottom: 5px;
    }
  }
  .gp_base-select_dropdown_item {
    padding: 11px 10px;
    text-align: left;
    transition: all 0.3s;
    background: $light1;
    cursor: pointer;
    border-left: 3px solid $light1;
    min-height: 40px;

    &.default-option {
      min-height: 50px;
    }

    p {
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden !important;
      text-overflow: ellipsis;
    }

    &:not(.active):hover {
      //background-color: $light2;
      //border-left: 3px solid $light2;
    }
    &.active {
      //background-color: $light2;
      //border-left: 3px solid $text-light-high;
    }
  }
  &.no-border {
    .gp_base-select_display {
      border: 1px solid transparent;
    }
  }
}

.border {
  border: 1px solid #494949 !important;
  border-radius: 3px;
}

.scrollBody {
  max-height: 165px;
  padding: 8px;
}

.transformY {
  transform: scaleY(-1);
}

.input-search__select {
  width: min-content !important;
  .gp_base-select_display {
    white-space: nowrap;
    width: fit-content;
    border-radius: 3px;
    padding: 11px 15px 11px 0px !important;
    border: none !important;
    &-label {
      display: none !important;
    }
    &-icon {
      width: 20px;
      height: 20px;
      @include flex-center;
    }
    > p {
      font-size: 12px;
      line-height: 14px;
      font-weight: 500;
      color: $text-light-high;
    }
    &_hidden {
      padding: 0px !important;
    }
    &:hover p {
      color: inherit !important;
    }
    &.border {
      border: none !important;
    }
  }
  .gp_base-select_dropdown {
    left: auto;
    width: 200px !important;
    top: 48px !important;
    box-shadow: 0px -2px 8px rgba(0, 0, 0, 0.06), 0px 2px 8px rgba(0, 0, 0, 0.12);
    .scrollBody {
      border-radius: 3px;
    }
    &_item {
      display: flex;
      justify-content: flex-start;
      padding: 12px 8px !important;
      border-left: none !important;
      border-radius: 3px;
      > p {
        font-size: 14px;
        line-height: 16px;
        font-weight: 500;
        // margin-left: 32px !important;
        text-overflow: inherit !important;
        overflow: hidden !important;
        -webkit-line-clamp: inherit !important;
      }
      &.active {
        position: relative;
        background: none !important;
        &:before {
          content: '\e95d';
          position: absolute;
          left: 12px;
          top: 10px;
          width: 16px;
          height: 16px;
          font-size: 16px;
          display: inline-block;
          font-family: 'gemicon' !important;
          color: #00c853;
        }
        &:hover {
          background: $light2 !important;
        }
      }
      &:hover {
        background-color: $light2;
      }
    }
  }
}
</style>
